Browser = require 'lib/browser'
track = require 'debug/track'
WarningBannerView = require 'views/header/warning-banner-view'

t = require('views/internal/teacup-with-helpers')('browser_will_be_unsupported')

template = t.renderable ->
  t.p '.u-bottom', ->
    browser = Browser.browserVersionStr

    if /explorer/.test(browser)
      t.format 'trello-is-ending-support-for-ie'
      t.text ' '
      t.format 'please-use-edge-or-the-desktop-client', {
        edge: 'https://support.microsoft.com/en-us/help/12435/windows-10-upgrade-faq',
        desktop: 'https://trello.com/platforms'
      }
    else if /^safari-[678]/.test(browser)
      if /^safari-6/.test(browser)
        t.format 'trello-is-ending-support-for-safari-6'
      else if /^safari-7/.test(browser)
        t.format 'trello-is-ending-support-for-safari-7'
      else
        t.format 'trello-is-ending-support-for-safari-8'
      t.text ' '
      t.format 'please-upgrade-to-safari-9-or-newer', {
        url: 'https://support.apple.com/downloads/safari'
      }

module.exports = class BrowserWillBeUnsupportedView extends WarningBannerView
  events:
    'click a': (e) ->
      track("Unsupported Browser Banner", "Clicked Upgrade", Browser.browserVersionStr)

  render: ->
    @$el.html(template())
    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/browser-will-be-unsupported-view.coffee